import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const ArrowGoForward10Stroke48: FC<IconProps> = ({
  size = 48,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path d="M32.0771 12.667L23.9971 17.333V13.7734C17.8906 13.7736 12.9308 18.7333 12.9307 24.8398C12.9307 30.9464 17.8906 35.9061 23.9971 35.9062C30.1037 35.9062 35.0645 30.9465 35.0645 24.8398C35.0644 22.8266 34.517 20.9332 33.5703 19.3066L35.5439 18.1729C36.6773 20.1328 37.331 22.4132 37.3311 24.8398C37.3311 32.1999 31.3571 38.1738 23.9971 38.1738C16.6372 38.1737 10.6641 32.1998 10.6641 24.8398C10.6642 17.48 16.6373 11.507 23.9971 11.5068V8L32.0771 12.667ZM26.832 19.6221C27.4502 19.6221 28.0334 19.736 28.5801 19.9648C29.0731 20.1936 29.5148 20.5421 29.9053 21.0098C30.253 21.4674 30.5394 22.0506 30.7637 22.7578C30.9345 23.4544 31.0329 24.2757 31.0596 25.2217C31.0329 26.2408 30.9189 27.1096 30.7168 27.8271C30.4718 28.5341 30.1705 29.1115 29.8125 29.5586C29.4115 29.9953 28.9692 30.3184 28.4863 30.5264C27.9605 30.724 27.4242 30.8223 26.8789 30.8223C26.2076 30.8222 25.6251 30.7083 25.1318 30.4795C24.5853 30.2507 24.143 29.9077 23.8057 29.4502C23.415 28.9822 23.2148 28.3989 22.9639 27.7021C22.8196 26.995 22.7203 26.1679 22.667 25.2217C22.7203 24.2132 22.8301 23.3555 22.9951 22.6484C23.2668 21.931 23.4829 21.3537 23.8838 20.917C24.2419 20.4698 24.6841 20.1416 25.21 19.9336C25.6928 19.7256 26.2335 19.6221 26.832 19.6221ZM20.4961 30.667H18.6709V21.915L16.3311 23.3662V21.4473L19.1387 19.6377H20.4961V30.667ZM26.8477 21.4473C26.4468 21.4473 26.114 21.5143 25.8496 21.6494C25.5422 21.7742 25.3028 21.9875 25.1318 22.2891C24.9076 22.5802 24.757 22.9704 24.6797 23.459C24.5594 23.9373 24.5124 24.5251 24.5391 25.2217C24.5124 25.9185 24.5646 26.507 24.6953 26.9854C24.7831 27.4636 24.9389 27.8538 25.1631 28.1553C25.3444 28.4464 25.5891 28.6597 25.8965 28.7949C26.1609 28.93 26.4885 28.997 26.8789 28.9971C27.2266 28.9971 27.5548 28.9353 27.8623 28.8105C28.1268 28.6753 28.3714 28.4621 28.5957 28.1709C28.7666 27.8694 28.912 27.4792 29.0322 27.001C29.1096 26.5122 29.1618 25.9185 29.1885 25.2217C29.1618 24.5251 29.1043 23.9425 29.0166 23.4746C28.886 22.9963 28.7301 22.6115 28.5488 22.3203C28.3246 22.0187 28.08 21.8002 27.8154 21.665C27.4976 21.5298 27.1746 21.4577 26.8477 21.4473Z" fill={color}/>
      </svg>
    </IconContainer>
  );
};
